// 我的学生
const studyPlan= () => import('@/views/studyPlan/index');
const studyPlan_studentQues_studentQues= () => import('@/views/studyPlan/studentQues/studentQues.vue');
const studyPlan_studentQues_studentMessage= () => import('@/views/studyPlan/studentQues/studentMessage.vue');
const studyPlan_studentQues_studentMessage_detail= () => import('@/views/studyPlan/studentQues/studentMessageDetail.vue');


const studyPlan_main= () => import('@/views/studyPlan/main');
const studyPlan_studentMessage= () => import('@/views/studyPlan/studentMessage/index');
const studyPlan_studentMessage_grade= () => import('@/views/studyPlan/studentMessage/grade/index');
const studyPlan_studentMessage_grade_list= () => import('@/views/studyPlan/studentMessage/grade/list');
const studyPlan_studentMessage_grade_detail = () => import('@/views/studyPlan/studentMessage/grade/detail');

const studyPlan_studentMessage_competition= () => import('@/views/studyPlan/studentMessage/competition/index');
const studyPlan_studentMessage_competition_list= () => import('@/views/studyPlan/studentMessage/competition/list');
const studyPlan_studentMessage_competition_detail = () => import('@/views/studyPlan/studentMessage/competition/detail');

const studyPlan_studentMessage_quality= () => import('@/views/studyPlan/studentMessage/quality/index');
const studyPlan_studentMessage_quality_list= () => import('@/views/studyPlan/studentMessage/quality/list');
const studyPlan_studentMessage_quality_detail = () => import('@/views/studyPlan/studentMessage/quality/detail');

const studyPlan_studentMessage_studentQues= () => import('@/views/studyPlan/studentMessage/studentQues/studentMessage.vue');
const studyPlan_studentMessage_parentQues = () => import('@/views/studyPlan/studentMessage/parentQues/parentMessage.vue');
const studyPlan_studentMessage_report= () => import('@/views/studyPlan/studentMessage/report/report');
const studyPlan_studentMessage_reportInterpretation=() => import('@/views/studyPlan/studentMessage/report/reportInterpretation');
const studyPlan_studentMessage_reportInterpretation2=() => import('@/views/studyPlan/studentMessage/report/reportInterpretation2');
const studyPlan_studentMessage_PartA=() => import('@/views/studyPlan/studentMessage/report/firstInterviewPartA');
//学习力测评报告
const studyPlan_studentMessage_reportLearning=() => import('@/views/studyPlan/studentMessage/reportLearning/learningReport2');
const studyPlan_studentMessage_reportLearning_unscramble=() => import('@/views/studyPlan/studentMessage/reportLearning/learningReportunscramble');

// 学习测评报告v3
const studyPlan_studentMessage_reportLearningv3=() => import('@/views/studyPlan/studentMessage/reportLearning/learningReport3');
const studyPlan_studentMessage_reportLearning_unscramble3=() => import('@/views/studyPlan/studentMessage/reportLearning/learningReportunscramble3'); // 解读



//规划内容调整
const studyPlan_planningContent= () => import('@/views/studyPlan/planningContent/index');
const studyPlan_planningContent_recordList= () => import('@/views/studyPlan/planningContent/recordList');
const studyPlan_planningContent_planningReport = () => import('@/views/studyPlan/planningContent/planningReport.vue');
const studyPlan_planningContent_adjustmentReport= () => import('@/views/studyPlan/planningContent/adjustmentReport.vue');

//
const studyPlan_consultationRecord= () => import('@/views/studyPlan/consultationRecord/index');
const studyPlan_consultationRecord_student= () => import('@/views/studyPlan/consultationRecord/student/index');
const studyPlan_consultationRecord_student_studentRecord=() => import('@/views/studyPlan/consultationRecord/student/list.vue');
const studyPlan_consultationRecord_student_detail= () => import('@/views/studyPlan/consultationRecord/student/detail.vue');

const studyPlan_consultationRecord_parent= () => import('@/views/studyPlan/consultationRecord/parent/index');
const studyPlan_consultationRecord_parent_parentRecord=() => import('@/views/studyPlan/consultationRecord/parent/list.vue');
const studyPlan_consultationRecord_parent_detail= () => import('@/views/studyPlan/consultationRecord/parent/detail.vue');



// 我的学生-数据分析
const studyPlan_dataAnalysis= () => import('@/views/studyPlan/dataAnalysis/index');
const studyPlan_dataAnalysis_actionPlan= () => import('@/views/studyPlan/dataAnalysis/actionPlan');
const studyPlan_dataAnalysis_grade= () => import('@/views/studyPlan/dataAnalysis/grade');

//我的学生-计划执行
const studyPlan_implement= () => import('@/views/studyPlan/implement/index');
const studyPlan_implement_targetSplit= () => import('@/views/studyPlan/implement/targetSplit');
const studyPlan_implement_actionPlan= () => import('@/views/studyPlan/implement/actionPlan');
const studyPlan_implement_assessment= () => import('@/views/studyPlan/implement/assessment');

//我的学生-计划执行-阶段评估
const studyPlan_implement_assessment_list= () => import('@/views/studyPlan/implement/assessment/list');
const studyPlan_implement_assessment_show= () => import('@/views/studyPlan/implement/assessment/show');

//我的学生-计划执行-目标拆分
const studyPlan_implement_targetSplit_list= () => import('@/views/studyPlan/implement/targetSplit/list');
const studyPlan_implement_targetSplit_show= () => import('@/views/studyPlan/implement/targetSplit/show');

//我的学生-计划执行-行动计划
const studyPlan_implement_actionPlan_list= () => import('@/views/studyPlan/implement/actionPlan/list');
const studyPlan_implement_actionPlan_show= () => import('@/views/studyPlan/implement/actionPlan/show');
const studyPlan_implement_actionPlan_gradeDetail= () => import('@/views/studyPlan/implement/actionPlan/gradeDetail');
const studyPlan_implement_actionPlan_gradeDetailassessment= () => import('@/views/studyPlan/implement/actionPlan/gradeDetailassessment');
const studyPlan_implement_actionPlan_assessmentShow= () => import('@/views/studyPlan/implement/actionPlan/assessmentShow');



// 成长档案
//我的学生-成长档案
const studyPlan_growthFile_index= () => import('@/views/studyPlan/growthFile/index');
const studyPlan_growthFile_entry=() => import('@/views/studyPlan/growthFile/entry.vue');
const studyPlan_growthFile_report = () => import('@/views/consultant/student/mine/main/growthFile/report.vue');
// const studyPlan_growthFile_report_index = () => import('@/views/consultant/student/mine/main/growthFile/index.vue');
export default
{
    path:'/studyPlan',
    name:'学业规划',
    redirect:'/studyPlan/main',
    component:studyPlan,
    meta:{requireAuth:true,roles:['student']},
    children:[
        {
            path: '/studyPlan/studentQues',
            component: studyPlan_studentQues_studentQues,
            meta:{requireAuth:true,roles:['student']},
        },
        {
            path: '/studyPlan/studentQuesMessage',
            component: studyPlan_studentQues_studentMessage,
            meta:{requireAuth:true,roles:['student']},
        },
        {
            path: '/studyPlan/studentQuesMessageDetail',
            component: studyPlan_studentQues_studentMessage_detail,
            meta:{requireAuth:true,roles:['student']},
        },
        {
            path: '/studyPlan/main',
            component: studyPlan_main,
            meta:{requireAuth:true,roles:['student']},
        },
        {
            path: "/studyPlan/studentMessage",
            component: studyPlan_studentMessage,
            redirect: '/studyPlan/studentMessage/grade',
            children: [
                {
                    path: '/studyPlan/studentMessage/grade',
                    component: studyPlan_studentMessage_grade,
                    redirect: '/studyPlan/studentMessage/grade/list',
                    children: [
                        {
                            path: '/studyPlan/studentMessage/grade/list',
                            component: studyPlan_studentMessage_grade_list,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/studentMessage/grade/detail',
                            component: studyPlan_studentMessage_grade_detail,
                            meta:{requireAuth:true,roles:['student']},
                        }]
                },
                {
                    path: '/studyPlan/studentMessage/competition',
                    component: studyPlan_studentMessage_competition,
                    redirect: '/studyPlan/studentMessage/competition/list',
                    children: [
                        {
                            path: '/studyPlan/studentMessage/competition/list',
                            component: studyPlan_studentMessage_competition_list,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/studentMessage/competition/detail',
                            component: studyPlan_studentMessage_competition_detail,
                            meta:{requireAuth:true,roles:['student']},
                        }
                    ]
                },
                {
                    path: '/studyPlan/studentMessage/quality',
                    component: studyPlan_studentMessage_quality,
                    redirect: '/studyPlan/studentMessage/quality/list',
                    children: [
                        {
                            path: '/studyPlan/studentMessage/quality/list',
                            component: studyPlan_studentMessage_quality_list,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/studentMessage/quality/detail',
                            component: studyPlan_studentMessage_quality_detail,
                            meta:{requireAuth:true,roles:['student']},
                        }
                    ]
                },
                {
                    path: '/studyPlan/studentMessage/student',
                    component: studyPlan_studentMessage_studentQues,
                    meta:{requireAuth:true,roles:['student']},
                },
                {
                    path: '/studyPlan/studentMessage/parent',
                    component: studyPlan_studentMessage_parentQues,
                    meta:{requireAuth:true,roles:['student']},
                },
                {
                    path: '/studyPlan/studentMessage/report',
                    component: studyPlan_studentMessage_report,
                    meta:{requireAuth:true,roles:['student']},
                },
                {
                    path: '/studyPlan/studentMessage/reportInterpretation',
                    component: studyPlan_studentMessage_reportInterpretation,
                    meta:{requireAuth:true,roles:['student']},
                },
                
                {
                    path: '/studyPlan/studentMessage/reportInterpretation2',
                    component: studyPlan_studentMessage_reportInterpretation2,
                    meta:{requireAuth:true,roles:['student']},
                },
                // 学习力测评报告
                {
                    path: '/studyPlan/studentMessage/reportLearning/learningReport2',
                    component: studyPlan_studentMessage_reportLearning,
                    meta:{requireAuth:true,roles:['student']},
                },
                //学习力测评报告解读
                {
                    path: '/studyPlan/studentMessage/reportLearning/learningReportunscramble',
                    component: studyPlan_studentMessage_reportLearning_unscramble,
                    meta:{requireAuth:true,roles:['student']},
                },
                // 学习力测评报告v3
                {
                    path:'/studyPlan/studentMessage/reportLearning/learningReport3',
                    component:studyPlan_studentMessage_reportLearningv3,
                    meta:{requireAuth:true,roles:['student']},

                },
                // 解读
                {                    
                    path: '/studyPlan/studentMessage/reportLearning/learningReportunscramble3',
                    component: studyPlan_studentMessage_reportLearning_unscramble3,
                    meta:{requireAuth:true,roles:['student']},
                }
            ]
        },
        {
            path: "/studyPlan/planningContent",
            component: studyPlan_planningContent,
            redirect: '/studyPlan/planningContent/recordList',
            children: [
                {
                    path: '/studyPlan/planningContent/recordList',
                    component: studyPlan_planningContent_recordList,
                    meta:{requireAuth:true,roles:['student']},
                },
                {
                    path: '/studyPlan/studentMessage/part_A',
                    component: studyPlan_studentMessage_PartA,
                    meta:{requireAuth:true,roles:['student']},
                },

                {
                    path: '/studyPlan/planningContent/planningReport',
                    component: studyPlan_planningContent_planningReport,
                    meta:{requireAuth:true,roles:['student']},
                },
                {
                    path: '/studyPlan/planningContent/adjustmentReport',
                    component: studyPlan_planningContent_adjustmentReport,
                    meta:{requireAuth:true,roles:['student']},
                },
            ]
        },
        {
            path:"/studyPlan/consultationRecord",
            component: studyPlan_consultationRecord,
            redirect:'/studyPlan/consultationRecord/student',
            children:[
                {
                    path: '/studyPlan/consultationRecord/student',
                    component: studyPlan_consultationRecord_student,
                    redirect:'/studyPlan/consultationRecord/student/studentRecord',
                    children:[
                        {
                            path: '/studyPlan/consultationRecord/student/studentRecord',
                            component: studyPlan_consultationRecord_student_studentRecord,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/consultationRecord/student/detail',
                            component: studyPlan_consultationRecord_student_detail,
                            meta:{requireAuth:true,roles:['student']},
                        },
                    ]
                },
                {

                    path: '/studyPlan/consultationRecord/parent',
                    component: studyPlan_consultationRecord_parent,
                    redirect:'/studyPlan/consultationRecord/parent/parentRecord',
                    children:[
                        {
                            path: '/studyPlan/consultationRecord/parent/parentRecord',
                            component: studyPlan_consultationRecord_parent_parentRecord,
                            meta:{requireAuth:true,roles:['student']},

                        },
                        {
                            path: '/studyPlan/consultationRecord/parent/detail',
                            component: studyPlan_consultationRecord_parent_detail,
                            meta:{requireAuth:true,roles:['student']},
                        },

                    ]
                },
            ]
        },
        {
            path: '/studyPlan/dataAnalysis',
            component: studyPlan_dataAnalysis,
            children: [
                {
                    path: '/studyPlan/dataAnalysis/grade',
                    component: studyPlan_dataAnalysis_grade,
                    meta:{requireAuth:true,roles:['student']},
                },
                {
                    path: '/studyPlan/dataAnalysis/actionplan',
                    component: studyPlan_dataAnalysis_actionPlan,
                    meta:{requireAuth:true,roles:['student']},
                }
            ]
        },
        {
            path: '/studyPlan/implement',
            component: studyPlan_implement,
            children: [
                {
                    path: '/studyPlan/implement/targetsplit',
                    component: studyPlan_implement_targetSplit,
                    redirect: '/studyPlan/implement/targetsplit/list',
                    children: [
                        {
                            path: '/studyPlan/implement/targetsplit/list',
                            component: studyPlan_implement_targetSplit_list,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/implement/targetsplit/show',
                            component: studyPlan_implement_targetSplit_show,
                            meta:{requireAuth:true,roles:['student']},
                        },
                    ]
                },
                {
                    path: '/studyPlan/implement/actionplan',
                    component: studyPlan_implement_actionPlan,
                    redirect: '/studyPlan/implement/actionplan/list',
                    children: [
                        {
                            path: '/studyPlan/implement/actionplan/list',
                            component: studyPlan_implement_actionPlan_list,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/implement/actionplan/show',
                            component: studyPlan_implement_actionPlan_show,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/implement/actionplan/gradeDetail',
                            component: studyPlan_implement_actionPlan_gradeDetail,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/implement/actionplan/gradeDetailassessment',
                            component: studyPlan_implement_actionPlan_gradeDetailassessment,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/implement/actionplan/assessmentShow',
                            component: studyPlan_implement_actionPlan_assessmentShow,
                            meta:{requireAuth:true,roles:['student']},
                        },
                    ]
                },
                {
                    path: '/studyPlan/implement/assessment',
                    component: studyPlan_implement_assessment,
                    redirect: '/studyPlan/implement/assessment/list',
                    children: [
                        {
                            path: '/studyPlan/implement/assessment/list',
                            component: studyPlan_implement_assessment_list,
                            meta:{requireAuth:true,roles:['student']},
                        },
                        {
                            path: '/studyPlan/implement/assessment/show',
                            component: studyPlan_implement_assessment_show,
                            meta:{requireAuth:true,roles:['student']},
                        },
                    ]
                },
            ]
        },
        {
            path:"/studyPlan/growthFile",
            component: studyPlan_growthFile_index,
            redirect:'/studyPlan/growthFile/entry',
            children:[
                {
                    path: '/studyPlan/growthFile/entry',
                    component: studyPlan_growthFile_entry,
                    meta:{requireAuth:true,roles:['student']},
                },
                {
                    path: '/studyPlan/growthFile/report',
                    component: studyPlan_growthFile_report,
                    meta:{requireAuth:true,roles:['student']},
                },
                // {
                //     path: '/studyPlan/growthFile/report_index',
                //     component: studyPlan_growthFile_report_index,
                //     meta:{requireAuth:true,roles:['student']},
                // },
                
            ]
        },



    ]
}
